/**
 * Validates form values against field definitions.
 * Returns an array of field IDs that have errors, plus an errorMessages map.
 */
export function validateForm(formValues, fields, conditionResults) {
    const errors = [];
    const errorMessages = {};

    if (!fields || !formValues) {
        return { errors, errorMessages };
    }

    fields.forEach((field) => {
        if (field.type === 'section' || field.type === 'hidden') {
            return;
        }

        // Skip validation for hidden (by condition) fields
        const condResult = conditionResults && conditionResults[field.fieldId];
        if (condResult && !condResult.visible) {
            return;
        }

        const value = formValues[field.fieldId];
        const validation = field.validation || {};
        const isRequired = (condResult && condResult.required) || validation.required;

        // Address fields have sub-field validation
        if (field.type === 'address') {
            // Address fields are optional by default unless configured otherwise
            return;
        }

        // Required check
        if (isRequired) {
            if (isEmpty(value, field.type)) {
                errors.push(field.fieldId);
                errorMessages[field.fieldId] = 'This field is required.';
                return;
            }
        }

        // Skip further validation if empty and not required
        if (isEmpty(value, field.type)) {
            return;
        }

        // MinLength
        if (validation.minLength && String(value).length < validation.minLength) {
            errors.push(field.fieldId);
            errorMessages[field.fieldId] = 'Minimum length is ' + validation.minLength + ' characters.';
            return;
        }

        // MaxLength
        if (validation.maxLength && String(value).length > validation.maxLength) {
            errors.push(field.fieldId);
            errorMessages[field.fieldId] = 'Maximum length is ' + validation.maxLength + ' characters.';
            return;
        }

        // Min (numeric)
        if (validation.min !== undefined && Number(value) < validation.min) {
            errors.push(field.fieldId);
            errorMessages[field.fieldId] = 'Minimum value is ' + validation.min + '.';
            return;
        }

        // Max (numeric)
        if (validation.max !== undefined && Number(value) > validation.max) {
            errors.push(field.fieldId);
            errorMessages[field.fieldId] = 'Maximum value is ' + validation.max + '.';
            return;
        }

        // Pattern
        if (validation.pattern) {
            const regex = new RegExp(validation.pattern);
            if (!regex.test(String(value))) {
                errors.push(field.fieldId);
                errorMessages[field.fieldId] = validation.patternMessage || 'Invalid format.';
                return;
            }
        }
    });

    return { errors, errorMessages };
}

function isEmpty(value, fieldType) {
    if (value === undefined || value === null || value === '') {
        return true;
    }
    if (fieldType === 'multiselect' || fieldType === 'objectIdRefMulti') {
        return Array.isArray(value) && value.length === 0;
    }
    return false;
}
